import { LogErrors } from './../../LogErrors'
import { DoubleAttempt } from './../Helpers/DoubleAttempt'


/**
 * Autoconsulta (rol 2): devuelve únicamente el propio registro del instructor dueño del
 * token (CenterUsers.Id se deriva del token, no se acepta ningún id de otro instructor).
 */
const GetAssignedLicensesForInstructor = async (idCenter, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, idUserRol: 2 })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetAssignedLicensesForInstructor`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetAssignedLicensesForInstructor - DL Instructor Licenses', error)
        return { success: false, message: `No ha sido posible obtener las licencias asignadas.` }
    }
}

/**
 * Autoconsulta (rol 2): total de licencias consumidas solo por los Ztudiantes del propio
 * instructor dueño del token.
 */
const GetTotalUsedLicenses = async (idCenter, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ idCenter, idUserRol: 2 })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetTotalUsedLicenses`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetTotalUsedLicenses - DL Instructor Licenses', error)
        return { success: false, message: `No ha sido posible obtener las licencias utilizadas.` }
    }
}

/**
 * Autoconsulta (rol 2): el campo idInstructor no existe aquí porque el backend lo
 * sobrescribe server-side con el CenterUsers.Id del propio instructor sin importar el
 * valor enviado, así que no tiene caso mandarlo. idCourse sigue siendo un filtro opcional.
 */
const GetUsedLicensesReport = async (idCenter, token, idCourse = null) => {
    try {
        const body = { idCenter, idUserRol: 2 }
        if (idCourse !== null) body.idCourse = idCourse

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(body)
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Reports/GetUsedLicensesReport`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetUsedLicensesReport - DL Instructor Licenses', error)
        return { success: false, message: `No ha sido posible obtener el reporte de licencias utilizadas.` }
    }
}

/**
 * Consulta si el centro está en modalidad de licencias gratuitas ("isFreeLicenses").
 * Se usa en el dashboard del Instructor para decidir si el tile "Licencias Ztudia" debe
 * habilitarse (isFreeLicenses === false) o permanecer deshabilitado (true).
 */
const GetCenterFreeLicensesStatus = async (idCenter, idUserRol, token) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({ IdCenter: idCenter, IdUserRol: idUserRol })
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Users/GetCenterFreeLicensesStatus`
        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetCenterFreeLicensesStatus - DL Instructor Licenses', error)
        return { success: false, message: `No ha sido posible consultar el estado de licencias gratuitas del centro.` }
    }
}

export { GetAssignedLicensesForInstructor, GetTotalUsedLicenses, GetUsedLicensesReport, GetCenterFreeLicensesStatus };
